export default {
  title: 'Meet Your Mentor',
  company: 'MYM',
  process: 'DEFAULT',
  basename: '',
  theme: 'light',
  i18n: 'en',
  tinyMCEKey: '7kiqm5c7crs3mdgf1lgiq973xn7kdxtf6ohasxhmkb2mpc45',
};
